<template>
  <svg
    class="text-darkBlue"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="19"
    viewBox="0 0 26 23"
    fill="none"
  >
    <path
      class="group-hover:stroke-blue"
      d="M23.9485 7.92188H1.88222C1.39498 7.92188 1 8.31287 1 8.79519V9.98118C1 10.4635 1.39498 10.8545 1.88222 10.8545H23.9485C24.4358 10.8545 24.8307 10.4635 24.8307 9.98118V8.79519C24.8307 8.31287 24.4358 7.92188 23.9485 7.92188Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      class="group-hover:stroke-blue"
      d="M23.5183 10.8289L21.6382 20.686C21.5279 21.2305 21.0446 21.6227 20.4837 21.6227H5.41111C4.84475 21.6227 4.35736 21.2224 4.25389 20.6712L2.3996 10.8289"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      class="group-hover:stroke-blue"
      d="M8.24701 13.0984V18.3262"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="group-hover:stroke-blue"
      d="M12.9835 13.0984V18.3262"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="group-hover:stroke-blue"
      d="M17.72 13.0984V18.3262"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="group-hover:stroke-blue"
      d="M4.20758 7.93264C5.02445 3.98923 8.56965 1 12.7847 1H13.0447C17.2584 1 20.8009 3.98653 21.6205 7.9259"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
<script>
export default {
  name: "Basket",
};
</script>
